import { render, staticRenderFns } from "./iframeSrc.vue?vue&type=template&id=5b9c0608&scoped=true&"
import script from "./iframeSrc.vue?vue&type=script&lang=js&"
export * from "./iframeSrc.vue?vue&type=script&lang=js&"
import style0 from "./iframeSrc.vue?vue&type=style&index=0&id=5b9c0608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9c0608",
  null
  
)

export default component.exports